module.exports = __webpack_public_path__ + "img/hr-green-small-grass-01.99141735.png";